import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { ITouchPointConfiguration } from '../../interfaces/dtos/ITouchPointConfiguration';
import { ITouchPointConfigState } from '../../interfaces/states/ITouchPointConfigState';

const initialState: ITouchPointConfigState = {
  touchPointConfiguration: {
    defaultWeightUnitOfMeasurePrecision: 2,
    defaultAmountDecimalPrecision: 2,
    alternateIdMinLength: 5,
    alternateIdMaxLength: 11,
    alternateIdSellingEngineMinLength: 1,
    alternateIdSellingEngineMaxLength: 10,
  },
};
class TouchpointReducer extends ImmerReducer<ITouchPointConfigState> {
  public setTouchpointConfig(tpConfig: Partial<ITouchPointConfiguration>): void {
    this.draftState.touchPointConfiguration = {
      ...initialState.touchPointConfiguration,
      ...tpConfig,
    };
  }

  public setShowDepositItems(showDepositItems: boolean): void {
    this.draftState.touchPointConfiguration = {
      ...this.draftState.touchPointConfiguration,
      depositConfigurations: {
        displayDepositItemOnCashierDisplayAndCustomerDisplay: showDepositItems,
      },
    };
  }
}

export const TouchpointActions = createActionCreators(TouchpointReducer);
export const TouchpointReducerFunction = createReducerFunction(TouchpointReducer, initialState);
